import React, { useEffect } from 'react';

const hostingServicesData = [
  { 
    title: 'Domain Registration', 
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
        <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912l-.003.002-.34.18a.75.75 0 01-.707 0A50.009 50.009 0 007.5 12.174v-.224c0-.131.067-.248.172-.311a54.614 54.614 0 014.653-2.52.75.75 0 00-.65-1.352 56.129 56.129 0 00-4.78 2.589 1.858 1.858 0 00-.859 1.228 49.803 49.803 0 00-4.634-1.527.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
        <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
        <path d="M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z" />
      </svg>
    ),
    description: "Secure your brand's online identity with the perfect domain name.",
    features: [
      "Domain name search & registration (.com, .ca, .net & more)",
      "Domain transfer & renewal management",
      "Private domain registration & WHOIS protection"
    ],
    callToAction: "Claim Your Perfect Domain Name Today!"
  },
  { 
    title: 'Website Hosting', 
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
        <path fillRule="evenodd" d="M2.25 5.25a3 3 0 013-3h13.5a3 3 0 013 3V15a3 3 0 01-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 01-.53 1.28h-9a.75.75 0 01-.53-1.28l.621-.622a2.25 2.25 0 00.659-1.59V18h-3a3 3 0 01-3-3V5.25zm1.5 0v9.75c0 .83.67 1.5 1.5 1.5h13.5c.83 0 1.5-.67 1.5-1.5V5.25c0-.83-.67-1.5-1.5-1.5H5.25c-.83 0-1.5.67-1.5 1.5z" clipRule="evenodd" />
      </svg>
    ),
    description: "Fast, secure, and fully managed hosting solutions for businesses of all sizes.",
    features: [
      "Shared, VPS & Dedicated Hosting options",
      "Optimized for WordPress, eCommerce & custom websites",
      "Automatic backups & 24/7 technical support"
    ],
    callToAction: "Host Your Website on a Secure & High-Speed Server!"
  },
  { 
    title: 'Business Email Hosting', 
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
        <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
        <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
      </svg>
    ),
    description: "Professional, custom email addresses that build trust & credibility.",
    features: [
      "@yourdomain.com business emails",
      "Spam protection & advanced security filters",
      "Sync with Outlook, Gmail & mobile devices"
    ],
    callToAction: "Get a Professional Email Address for Your Business!"
  },
  { 
    title: 'Security & SSL Certificates', 
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
        <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
      </svg>
    ),
    description: "Protect your website, data & customer information with enterprise-level security.",
    features: [
      "SSL certificates for HTTPS & encryption",
      "Firewall protection & malware scanning",
      "DDoS attack prevention & data encryption"
    ],
    callToAction: "Secure Your Website with Advanced Protection Today!"
  }
];

const benefitsData = [
  {
    title: "Blazing Fast Website Speeds",
    description: "We use advanced caching & CDN technology for lightning-fast load times."
  },
  {
    title: "24/7 Expert Support",
    description: "Our dedicated support team is available anytime you need help."
  },
  {
    title: "Scalable & Flexible Plans",
    description: "From startups to enterprises, we have hosting solutions for every business."
  },
  {
    title: "Secure & Reliable Servers",
    description: "We offer premium security features to protect your website & data."
  }
];

const HostingServices = () => {
  useEffect(() => {
    // Initialize any animations if needed
  }, []);

  return (
    <section className="relative bg-black text-white py-20 px-4 md:px-12 lg:px-20">
      {/* Background Gradient Blur */}
      <div className="absolute inset-0 bg-gradient-to-br from-neutral-900 to-black opacity-90 pointer-events-none"></div>
      
      <div className="relative z-10 container mx-auto max-w-6xl">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block text-yellow-500 text-sm uppercase tracking-wider mb-4">
            HOSTING SERVICES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-neutral-200 to-neutral-500">
            Transform Challenges into Opportunities with Technology
          </h2>
          <p className="text-neutral-400 max-w-3xl mx-auto mt-4 text-lg">
            We offer a comprehensive range of hosting services designed to help businesses thrive in a competitive digital landscape.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {hostingServicesData.map((service, index) => (
            <div 
              key={index}
              className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 space-y-4 group hover:bg-neutral-800 transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl"
            >
              {/* Icon Container */}
              <div className="w-16 h-16 bg-yellow-500 rounded-xl flex items-center justify-center text-black">
                {service.icon}
              </div>
              
              {/* Service Title */}
              <h3 className="text-xl font-semibold text-white group-hover:text-yellow-500 transition-colors">
                {service.title}
              </h3>
              
              {/* Service Description */}
              <p className="text-neutral-400">
                {service.description}
              </p>
              
              {/* Features List */}
              <div className="space-y-2">
                <p className="text-sm text-yellow-500 font-medium">What We Offer:</p>
                <ul className="space-y-1">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-yellow-500 mr-2">✓</span>
                      <span className="text-neutral-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Call to Action */}
              <p className="text-sm font-medium text-yellow-500">
                {service.callToAction}
              </p>
            </div>
          ))}
        </div>

        {/* Benefits Section */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-center text-white mb-10">
            Why Our Hosting Services Stand Out?
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8">
            {benefitsData.map((benefit, index) => (
              <div 
                key={index}
                className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 hover:bg-neutral-800 transition-all duration-300 ease-in-out"
              >
                <h4 className="text-lg font-semibold text-yellow-500 mb-2">
                  ✓ {benefit.title}
                </h4>
                <p className="text-neutral-400 text-sm">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Explore More Button */}
        <div className="text-center mt-16">
          <button 
            className="inline-block px-10 py-4 bg-yellow-500 text-black font-semibold rounded-full hover:bg-yellow-600 transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl"
          >
            Power Your Business with Reliable Hosting – Get Started Today!
          </button>
        </div>
      </div>
    </section>
  );
}

export default HostingServices;